import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

interface ContributorOptionType {
  inputValue?: string;
  key?: string;
  value: string | number;
}

export interface ICreatable {
  contributorsList: any
  value?: ContributorOptionType | null | any;
  onChange?: any;
  label?: any;
}

const filter = createFilterOptions<ContributorOptionType>();

export default function AutocompleteCreatable(props: ICreatable) {
  const { contributorsList, onChange, label } = props;
  const [value, setValue] = React.useState<any>(null);

  let finalValue;

  React.useEffect(() => {
    finalValue = typeof value === 'string'
      ? value
      : typeof value === 'object'
        ? value?.value
        : ''; 
  }, [value]);
  

  return (<div>
    <Autocomplete 
      value={finalValue}
      onChange={(event, newValue: any) => {
        if (typeof newValue === 'string') {
          onChange(newValue);
          setValue({
            value: newValue
          });
        } else if (newValue && newValue.inputValue) {
          // Create a new value from the user input
          onChange(newValue, true);
          setValue({
            value: newValue.inputValue,
          });
        } else {
          onChange(newValue, false);
          setValue(newValue);
        }
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        const { inputValue } = params;

        // Suggest the creation of a new value
        const isExisting = options.findIndex((option) => inputValue === option.key) !==-1;   
     
        if (inputValue !== '' && !isExisting) {

          filtered.push({
            inputValue,
            key: `Προσθήκη "${inputValue}"`,
            value: ''
          });
        }

        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      fullWidth
      id='creatable'
      options={contributorsList}
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
          return option;
        }
        // Add x option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        
        return option.key;
      }}
      
      renderOption={(props, option) => 
      {
        const temp= <li {...props}>{option.key}</li>;
        return temp;
      }}
      freeSolo
      renderInput={(params) => (
        <TextField {...params} label={label} />
      )}
    />
  </div>);
}
